import React, { useEffect } from 'react';

const FuturesBelowInfo = ({ mxLng, setMxLng, mxShrt, setMxShrt, tradePreliminary, quantity, priceStatic, pairDetails, tabMenu, trades, xMenu, feeRateObj, walletBalance = 0 }) => {
    const TAKER_FEE_RATE = Number(feeRateObj?.takerFeeRate) || 0;

    const orderPrice =
        tabMenu === 'Market'
            ? Number(pairDetails?.data?.lastPrice) || 0
            : Number(priceStatic) || 0;

    const leverage = Number(xMenu) || 0;

    const orderValue = Number(quantity) || 0;
    const contractQuantity =
        orderPrice > 0 && orderValue > 0
            ? orderValue / orderPrice
            : 0;

    const calculateOrderCost = (side) => {
        if (
            contractQuantity <= 0 ||
            orderPrice <= 0 ||
            leverage <= 0
        ) {
            return 0;
        }

        const initialMargin =
            (contractQuantity * orderPrice) / leverage;

        const feeToOpen =
            contractQuantity *
            orderPrice *
            TAKER_FEE_RATE;

        let feeToClose = 0;

        if (side === 'Long') {
            feeToClose =
                contractQuantity *
                orderPrice *
                (1 - 1 / leverage) *
                TAKER_FEE_RATE;
        } else {
            feeToClose =
                contractQuantity *
                orderPrice *
                (1 + 1 / leverage) *
                TAKER_FEE_RATE;
        }

        return initialMargin + feeToOpen + feeToClose;
    };

    const longCost = calculateOrderCost('Long');
    const shortCost = calculateOrderCost('Short');

    const currentPosition =
        trades?.positions?.list?.length > 0
            ? trades.positions.list.find(
                (data) =>
                    data?.symbol === pairDetails?.data?.symbol
            )
            : null;

    const currentPositionSize =
        Number(currentPosition?.size) || 0;

    const currentPositionSide =
        currentPosition?.side === 'Buy'
            ? 'Long'
            : currentPosition?.side === 'Sell'
                ? 'Short'
                : '';

    useEffect(() => {
        const calculateMaxOrderValue = (side) => {
            const balance = Number(walletBalance) || 0;

            if (balance <= 0 || leverage <= 0) {
                return 0;
            }

            let costRatio = 0;

            if (side === 'Long') {
                costRatio =
                    (1 / leverage) +
                    TAKER_FEE_RATE +
                    ((1 - 1 / leverage) * TAKER_FEE_RATE);
            } else {
                costRatio =
                    (1 / leverage) +
                    TAKER_FEE_RATE +
                    ((1 + 1 / leverage) * TAKER_FEE_RATE);
            }

            if (costRatio <= 0) {
                return 0;
            }

            return balance / costRatio;
        };
        const maxLong = calculateMaxOrderValue('Long');
        const maxShort = calculateMaxOrderValue('Short');
        setMxLng(Number(maxLong) || 0);
        setMxShrt(Number(maxShort) || 0);
    }, [walletBalance, leverage, setMxLng, setMxShrt, TAKER_FEE_RATE, priceStatic, quantity]);

    const formatCost = (value) => {
        return (Number(value) || 0).toFixed(4);
    };

    const formatMax = (value) => {
        return (Number(value) || 0).toFixed(4);
    };

    return (
        <div className="d-flex justify-content-between align-items-center overflow-hidden">
            <div>
                <button
                    onClick={() =>
                        tradePreliminary('buy', 'long')
                    }
                >
                    LONG
                </button>

                <div className="mt-2 pt-1 handleCostMaxText w-100">
                    <p className="mb-1">
                        COST {formatCost(longCost)} USDT
                    </p>

                    <p>
                        MAX {formatMax(mxLng)} USDT
                    </p>
                </div>
            </div>

            <div>
                <button
                    onClick={() =>
                        tradePreliminary('sell', 'short')
                    }
                >
                    SHORT
                </button>

                <div className="mt-2 pt-1 handleCostMaxText w-100 text-end">
                    <p className="mb-1">
                        COST {formatCost(shortCost)} USDT
                    </p>

                    <p>
                        MAX {formatMax(mxShrt)} USDT
                    </p>
                </div>
            </div>
        </div>
    );
};

export default FuturesBelowInfo;